module.exports = __webpack_public_path__ + "DheerajDhall-9d901bf9.webp";